window.__ERPHOSTMAP__ = {
  // 本地环境
  local: {
    env: 'dev',
    login: 'https://cas.dev.ky-tech.com.cn'
  },
  // dev环境
  'http://edge.dev.kye-erp.com': {
    env: 'dev',
    login: 'https://cas.dev.ky-tech.com.cn'
  },
  'https://edge.dev.kye-erp.com': {
    env: 'dev',
    login: 'https://cas.dev.ky-tech.com.cn'
  },
  'http://edge.test.kye-erp.com': {
    env: 'test',
    host: 'http://openapi-test.kyeapi.com',
    login: 'http://cas.test.ky-tech.com.cn'
  },
  // stg环境
  'http://edge-stg.kye-erp.com': {
    env: 'stg',
    login: 'https://cas-stg.ky-tech.com.cn'
  },
  'https://edge-stg.kye-erp.com': {
    env: 'stg',
    login: 'https://cas-stg.ky-tech.com.cn'
  },
  // uat环境
  'http://edge.uat.kye-erp.com': {
    env: 'uat',
    login: 'https://cas-uat.kye-erp.com'
  },
  'https://edge.uat.kye-erp.com': {
    env: 'uat',
    login: 'https://cas-uat.kye-erp.com'
  },
  // uat 亮剑环境
  'http://edge-uat.ky-liangjian.com': {
    env: 'uat',
    login: 'https://cas-uat.kye-erp.com'
  },
  'https://edge-uat.ky-liangjian.com': {
    env: 'uat',
    login: 'https://cas-uat.kye-erp.com'
  },
  // sit培训环境
  'http://sit.kye-erp.com': {
    env: 'sit',
    login: 'http://cas.sit.ky-tech.com.cn'
  },
  'http://edge-sit.kye-erp.com': {
    env: 'sit',
    login: 'https://cas-uat.kye-erp.com'
  },
  'https://edge-sit.kye-erp.com': {
    env: 'sit',
    login: 'https://cas-uat.kye-erp.com'
  },
  // str压测环境
  'http://edge.str.kye-erp.com': {
    env: 'str',
    host: 'http://open-str.kyepm.com',
    login: 'http://cas.str.ky-tech.com.cn'
  },
  'https://edge.str.kye-erp.com': {
    env: 'str',
    login: 'https://cas-str.ky-tech.com.cn'
  },
  // 生产环境
  'http://www.kye-erp.com': {
    env: 'prd',
    host: 'https://api.ky-express.com',
    login: 'https://cas.kye-erp.com'
  },
  'https://www.kye-erp.com': {
    env: 'prd',
    host: 'https://api.ky-express.com',
    login: 'https://cas.kye-erp.com'
  },
  // 生产亮剑环境
  'http://www.ky-liangjian.com': {
    env: 'prd',
    login: 'https://cas.kye-erp.com'
  },
  'https://www.ky-liangjian.com': {
    env: 'prd',
    login: 'https://cas.kye-erp.com'
  }
}

window.__ERPAPPKEY__ = {
  address: '10205',
  agent: '50336',
  ai: '50222',
  ams: '50292',
  as: '50121',
  atc: '50272',
  atm: '50272',
  auth: '10132',
  autoph: '50101',
  baseconfig: '10144',
  baseService: '55033',
  bigdata: '10135',
  cabin: '50086',
  cas: '50030',
  cc: '10195',
  cod: '50278',
  coo: '50067',
  crm: '10201',
  crm$$: '10201',
  cts: '50159',
  data: '10143',
  dataconnect: '10124',
  datalog: '10124',
  devopsdashboard: '50178',
  ec: '50297',
  ecs: '10141',
  ers: '10214',
  fcs: '50020',
  fdb: '50177',
  file: '10124',
  filetool: '10124',
  fms: '10147',
  fmsaps: '50043',
  fmsocr: '50033',
  fps: '50022',
  hr: '10179',
  iaa: '10184',
  ims: '10164',
  ktree: '50273',
  kts: '50093',
  kuasheng: '10184',
  kyact: '50040',
  kye_map: '50243',
  kyemap: '50146',
  KYLDApi: '10182',
  ldp: '50111',
  map: '50206',
  mcs: '50178',
  notify: '10166',
  oams: '10173',
  oilms: '10131',
  oms: '10123',
  openapi: '10134',
  partner: '50016',
  pda: '10162',
  pdadata: '11000',
  pms: '10172',
  'schedule-center-kye': '55022',
  star: '50211',
  syslog: '10124',
  system: '10124',
  tds: '55027',
  third: '10169',
  tic: '50011',
  tms: '10146',
  tosapi: '10192',
  tosreport: '50302',
  urm: '50030',
  vms: '10131',
  was: '50010',
  zc: '10141'
}

window.__ERPGLOABLECONFIG__ = {
  title: '铸剑',
  maskSec: '✽✽✽',
  maskTips: '如非必要请勿查看，此操作会联动风控系统监控！',
  saveTips: '您确定要取消保存当前数据？',
  exportTips: '是否要导出当前页数据？(数据导出将被后台监控)',
  cacheMaxAge: 2 * 3600,
  logCountThreshold: 10,
  logTimeThreshold: 10,
  webSocketTick: 600,
  dateRangeIntercept: true,
  dateRange90: '“$1”跨度超过3个月',
  dateRange180: '“$1”跨度超过6个月',
  dateRange360: '“$1”跨度超过1年',
  dateRangeAppend: '，是否继续查询？',
  SAFE_TIPS_TITLE: '商业信息安全警告!!!',
  SAFE_TIPS_CONTENT: `<p>信息安全是公司不容侵犯的底线，勿使用不齿手段非法窃取，否则跨越将追究其民事及刑事责任，移交司法机关，使其得到法律的严惩！</p><br/>
      <p>1、机密信息包含客户信息、业务报价、客户合约、内部培训资料、系统源码等</p>
      <p>2、勿截图或下载公司机密信息发给外部人员</p>
      <p>3、若发现有内部人员泄露机密信息可举报到“总裁热线”，核实属实将给予奖励！</p><br/>
      <p>注：现公司已启用全方位视频监控系统、文件加密系统、用户行为监控系统等多重保护，任何妄图窃取公司商业信息或内部机密的行为都将无所遁形！</p><br/>
      <p style="color:red;">忠告各位同仁：切莫自毁前程、以身试法！</p>`
}

export default { ...window.__ERPHOSTMAP__ }



// WEBPACK FOOTER //
// ./src/public/config/host.js